import * as type from '../actions/types';

const initialState = {
    loading: false,
    error: null,
    success: null,
}

export default function registerResendOtp(state = initialState, action) {
    switch (action.type) {
        case type.GET_REGISTER_RESEND_OTP_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.GET_REGISTER_RESEND_OTP_SUCCESS:
            return {
                ...state,
                loading: false,
                success: action.data?.data?.message || "OTP sent successfully",
                error: null,
            }
        case type.GET_REGISTER_RESEND_OTP_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
                success: null,
            }
        case type.CLEAR_REGISTER_RESEND_OTP_MESSAGES:
            return {
                ...state,
                error: null,
                success: null,
            }
        default:
            return state
    }
}